import {Button, Grid, IconButton, Typography} from "@mui/material";
import {creatingClaim, getMetaDataList} from "../utils/API";
import React, {Fragment, useEffect, useRef, useState} from "react";
import InputComponent from "./core/InputComponent";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import CloseIcon from "@mui/icons-material/Close";
import SelectComponent from "./core/SelectComponent";
import Moment from "moment";
import DateFilter from "./core/DateFilter";
import AutocompleteComponent from "./core/Autocomplete";
import {SmallLightTooltip} from "./core/Tooltip";
import PDFLOGO from "../assets/pdfPreview.png";
import {getLocalStorageHospitalCode} from "../constants/UserAuth";

function CreateClaimManual(props) {
    const hosCode = getLocalStorageHospitalCode();
    const [metaList, setMetaList] = useState({});
    const [formData, setFormData] = useState({
        patientName: "",
        intimationNumber: "",
        patientAge: 0,
        hospitalId: "",
        procedureId: "",
        roomType: "",
        productCode: "",
        claimType: "",
        claimTransactionType: "",
        copayZone: "",
        policyVariant: "",
        reasonForHospitalization: "",
        remainingSumInsured: 0,
        baseSumInsured: 0,
        dateOfFirstDiagnosis: Moment(new Date()).format("YYYY-MM-DD"),
        dateOfAdmission: Moment(new Date()).format("YYYY-MM-DD"),
        dateOfDischarge: Moment(new Date()).format("YYYY-MM-DD"),
        currentPolicyInceptionDate: Moment(new Date()).format("YYYY-MM-DD"),
        currentPolicyStartDate: Moment(new Date()).format("YYYY-MM-DD"),
        currentPolicyEndDate: Moment(new Date()).format("YYYY-MM-DD"),
        // policyRenewalHistory:[]
    });
    const [formDocuments, setFormDocuments] = useState([]);
    const [disableSubmit, setDisableSubmit] = useState(true);
    const [docObjects, setDocObjects] = useState([]);
    const [roomList, setRoomList] = useState(["Select hospital name"]);

    const fileInputRef = useRef(null);

    useEffect(() => {
        FetchMetaData();
    }, []);

    useEffect(() => {
        if (formData.hospitalId !== "") {
            let roomType = metaList["hospitalServiceList"].filter(
                (val) => val.hospitalId === formData.hospitalId
            );
            setRoomList(roomType);
            disableSubmition();
        }
    }, [formData]);

    const handleSubmit = async () => {
        let form = new FormData();
        form.append("enhancementData", JSON.stringify(formData));
        formDocuments.forEach((doc) => {
            form.append("billFiles", doc);
        });
        let CreateClaim = await creatingClaim(form);
        CreateClaim.success === true && props.setOpen(false);
        CreateClaim.success === true && props.setOpen(false);
        CreateClaim.success === true &&
        props.setShowSnackbar({
            status: true,
            message: "Your request has been received successfully",
            severity: "success",
        });
        CreateClaim.success === false &&
        props.setShowSnackbar({
            status: true,
            message: CreateClaim?.message?.text,
            severity: "error",
        });
    };

    const FetchMetaData = async () => {
        try {

            let response = await getMetaDataList();
            const updatedResponseData = {
                ...response.data, // Keep all other properties of response.data
                medicalEventList: response.data.medicalEventList.map(event => ({
                    id: event.name, // Replace id with name
                    name: event.name, // Keep the name field unchanged
                })),
            };
            setMetaList(updatedResponseData);
        } catch (error) {
            console.error("Error fetching metadata:", error);
        }
    };

    function handleDocUpload(e) {
        const selectedDocs = Array.from(e.target.files);

        setFormDocuments(selectedDocs);
        const docsUpload = [...docObjects];
        selectedDocs.some((file) => {
            docsUpload.push({
                url: URL.createObjectURL(file),
                type: file.type,
                name: file.name,
            });
        });

        setDocObjects(docsUpload);
    }

    const handleRemoveDocuments = (docs, index) => {
        const documentList = docObjects.filter(
            (item, docIndex) => docIndex !== index
        );

        // Set the current context of Input to null to be able to fire onChange again in case of selecting already selected File after remove
        fileInputRef.current.value = null;
        setFormDocuments(documentList);

        setDocObjects(documentList);
    };

    const handleDateChange = (date, field) => {
        const formattedDate = Moment(date).format("YYYY-MM-DD");
        field === "dateOfFirstDiagnosis" &&
        setFormData({...formData, dateOfFirstDiagnosis: formattedDate});
        field === "dateOfAdmission" &&
        setFormData({...formData, dateOfAdmission: formattedDate});
        field === "dateOfDischarge" &&
        setFormData({...formData, dateOfDischarge: formattedDate});
        field === "currentPolicyInceptionDate" &&
        setFormData({...formData, currentPolicyInceptionDate: formattedDate});
        field === "currentPolicyStartDate" &&
        setFormData({...formData, currentPolicyStartDate: formattedDate});
        field === "currentPolicyEndDate" &&
        setFormData({...formData, currentPolicyEndDate: formattedDate});
    };
    const handleSelecteAutoComplete = (props) => {
        setFormData({...formData, procedureId: props?.id});
    };
    const disableSubmition = () => {
        if (
            formData &&
            formData.intimationNumber !== "" &&
            formData.patientAge !== 0 &&
            formData.patientName !== "" &&
            formData.hospitalId !== "" &&
            formData.procedureId !== "" &&
            formData.remainingSumInsured !== 0 &&
            formData.baseSumInsured !== 0 &&
            formData.reasonForHospitalization !== "" &&
            formData.productCode !== "" &&
            formData.roomType !== ""
        ) {
            setDisableSubmit(false);
        }
    };
    return (
        <Grid style={{padding: "1.5rem"}}>
            <form>
                <Typography variant="h6" color="primary" gutterBottom>
                    Enter Claim Information
                </Typography>

                <Grid
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 25,
                        padding: "1rem",
                    }}
                >
                    <Grid container style={{display: "flex", gap: 30}}>
                        <Grid item lg md xl>
                            <InputComponent
                                placeHolder="Enter Claim Intimation Number"
                                label="Claim Intimation Number"
                                required={true}
                                fullWidth={true}
                                handleChange={(e) =>
                                    setFormData({...formData, intimationNumber: e.target.value})
                                }
                            />
                        </Grid>

                        <Grid item lg md xl>
                            <SelectComponent
                                label={"Treatment Type"}
                                menuItem={[
                                    {id: "SURGICAL", name: "Surgical"},
                                    {id: "MEDICAL", name: "Medical"},
                                ]}
                                required={true}
                                setSelections={(data) =>
                                    setFormData({
                                        ...formData,
                                        treatmentType: data,
                                    })
                                }
                                style={{margin: 0}}
                            />
                        </Grid>
                    </Grid>
                    <Grid container style={{display: "flex", gap: 30}}>
                        <Grid item lg md xl>
                            <InputComponent
                                placeHolder="Enter Patient Name"
                                label="Patient Name"
                                fullWidth={true}
                                required={true}
                                handleChange={(e) =>
                                    setFormData({...formData, patientName: e.target.value})
                                }
                            />
                        </Grid>
                        <Grid item lg md xl>
                            <InputComponent
                                placeHolder="Enter Patient Age"
                                label="Patient Age"
                                fullWidth={true}
                                required={true}
                                type={"number"}
                                handleChange={(e) =>
                                    setFormData({
                                        ...formData,
                                        patientAge: parseInt(e.target.value),
                                    })
                                }
                                error={
                                    /[+\-*/e]/.test(formData.patientAge) ||
                                    !/^[0-9]*$/.test(formData.patientAge)
                                }
                                helperText={
                                    /[+\-*/e]/.test(formData.patientAge) ||
                                    !/^[0-9]*$/.test(formData.patientAge)
                                        ? "Enter proper amount"
                                        : ""
                                }
                            />
                        </Grid>
                    </Grid>
                    <Grid container style={{display: "flex", gap: 30}}>
                        <Grid item lg md xl>
                            <SelectComponent
                                label={"Hospital List"}
                                menuItem={metaList["hospitalList"]}
                                required={true}
                                setSelections={(data) =>
                                    setFormData({
                                        ...formData,
                                        hospitalId: data,
                                    })
                                }
                                style={{margin: 0}}
                            />
                        </Grid>
                        <Grid item lg md xl>
                            <SelectComponent
                                label={"Product Code"}
                                menuItem={metaList["policyProductList"]}
                                required={true}
                                setSelections={(data) =>
                                    setFormData({
                                        ...formData,
                                        productCode: data,
                                    })
                                }
                                style={{margin: 0}}
                            />
                        </Grid>
                    </Grid>
                    <Grid container style={{display: "flex", gap: 30}}>
                        <Grid item lg md xl>
                            <InputComponent
                                placeHolder="Enter Remaining Sum Insured"
                                required={true}
                                label="Remaining Sum Insured"
                                fullWidth={true}
                                type={"number"}
                                handleChange={(e) => {
                                    setFormData({
                                        ...formData,
                                        remainingSumInsured: parseInt(e.target.value),
                                    });
                                }}
                                error={
                                    /[+\-*/e]/.test(formData.remainingSumInsured) ||
                                    !/^[0-9]*$/.test(formData.remainingSumInsured)
                                }
                                helperText={
                                    /[+\-*/e]/.test(formData.remainingSumInsured) ||
                                    !/^[0-9]*$/.test(formData.remainingSumInsured)
                                        ? "Enter proper amount"
                                        : ""
                                }
                            />
                        </Grid>
                        <Grid item lg md xl>
                            <InputComponent
                                placeHolder="Enter Base Sum Insured"
                                label="Base Sum Insured"
                                required={true}
                                fullWidth={true}
                                handleChange={(e) => {
                                    setFormData({
                                        ...formData,
                                        baseSumInsured: parseInt(e.target.value),
                                    });
                                }}
                                type={"number"}
                                error={
                                    /[+\-*/e]/.test(formData.baseSumInsured) ||
                                    !/^[0-9]*$/.test(formData.baseSumInsured)
                                }
                                helperText={
                                    /[+\-*/e]/.test(formData.baseSumInsured) ||
                                    !/^[0-9]*$/.test(formData.baseSumInsured)
                                        ? "Enter proper amount"
                                        : ""
                                }
                            />
                        </Grid>
                        <Grid item lg md xl>
                            <SelectComponent
                                label={"Claim Transaction Type"}
                                menuItem={
                                    metaList["claimTransactionTypeList"] || [
                                        "CASHLESS",
                                        "REIMBURSEMENT",
                                    ]
                                }
                                setSelections={(data) =>
                                    setFormData({
                                        ...formData,
                                        claimTransactionType: data,
                                    })
                                }
                                style={{margin: 0}}
                            />
                        </Grid>
                    </Grid>
                    {/* Reason */}
                    <Grid container style={{display: "flex", gap: 30}}>
                        <Grid item lg md xl>
                            <SelectComponent
                                menuItem={metaList["medicalEventList"]}
                                label={"Reason For Hospitalization"}
                                required={true}
                                style={{margin: 0}}
                                setSelections={(data) =>
                                    setFormData({
                                        ...formData,
                                        reasonForHospitalization: data,
                                    })
                                }
                            />
                        </Grid>
                        <Grid item lg md xl>
                            <SelectComponent
                                label={"Claim Type"}
                                menuItem={metaList["claimTypeList"]}
                                setSelections={(data) =>
                                    setFormData({
                                        ...formData,
                                        claimType: data,
                                    })
                                }
                                style={{margin: 0}}
                            />
                        </Grid>
                    </Grid>
                    {/* DropDowns */}
                    <Grid container style={{display: "flex", gap: 30}}>
                        <Grid item lg md xl>
                            <AutocompleteComponent
                                data={metaList["procedureList"]}
                                handleSelecteAutoComplete={handleSelecteAutoComplete}
                                label={"Procedure List"}
                                required={true}
                            />
                            {/* <SelectComponent
                menuItem={metaList["procedureList"]}
                required={true}
                label={"Procedure List"}
                setSelections={(data) =>
                  setFormData({
                    ...formData,
                    procedureId: data,
                  })
                }
                style={{ margin: 0 }}
              /> */}
                        </Grid>
                        <Grid item lg md xl>
                            <SelectComponent
                                menuItem={roomList}
                                required={true}
                                label={"Room Type"}
                                style={{margin: 0}}
                                setSelections={(data) =>
                                    setFormData({
                                        ...formData,
                                        roomType: data,
                                    })
                                }
                            />
                        </Grid>
                    </Grid>
                    {hosCode !== "INSURER-1001" && (
                        <Grid container style={{display: "flex", gap: 30}}>
                            <Grid Grid item lg md xl>
                                <SelectComponent
                                    menuItem={metaList["copayZoneList"]}
                                    required={true}
                                    label={"Copay Zone"}
                                    setSelections={(data) =>
                                        setFormData({
                                            ...formData,
                                            copayZone: data,
                                        })
                                    }
                                    style={{margin: 0}}
                                />
                            </Grid>
                            <Grid item lg md xl>
                                <SelectComponent
                                    menuItem={metaList["policyVariantList"]}
                                    required={true}
                                    label={"Policy Variant"}
                                    style={{margin: 0}}
                                    setSelections={(data) =>
                                        setFormData({
                                            ...formData,
                                            policyVariant: data,
                                        })
                                    }
                                />
                            </Grid>
                        </Grid>
                    )}

                    {/* Dates   */}
                    <Grid container style={{display: "flex", gap: 30}}>
                        <Grid
                            item
                            lg
                            md
                            xl
                            style={{display: "flex", flexDirection: "column"}}
                        >
                            <Typography variant="b" style={{opacity: "0.7"}}>
                                Date Of First Diagnosis *
                            </Typography>
                            <DateFilter
                                disableFuture={true}
                                fieldId={"dateOfFirstDiagnosis"}
                                selectedDate={formData.dateOfFirstDiagnosis}
                                onDateChange={handleDateChange}
                            />
                        </Grid>
                        <Grid
                            item
                            lg
                            md
                            xl
                            style={{display: "flex", flexDirection: "column"}}
                        >
                            <Typography variant="b" style={{opacity: "0.7"}}>
                                Date Of Admission *
                            </Typography>
                            <DateFilter
                                disableFuture={true}
                                fieldId={"dateOfAdmission"}
                                selectedDate={formData.dateOfAdmission}
                                onDateChange={handleDateChange}
                            />
                        </Grid>
                        <Grid
                            item
                            lg
                            md
                            xl
                            style={{display: "flex", flexDirection: "column"}}
                        >
                            <Typography variant="b" style={{opacity: "0.7"}}>
                                Date Of Discharge *
                            </Typography>
                            <DateFilter
                                disableFuture={true}
                                fieldId={"dateOfDischarge"}
                                selectedDate={formData.dateOfDischarge}
                                onDateChange={handleDateChange}
                            />
                        </Grid>
                    </Grid>
                    {/* Date Selections */}

                    <Grid container style={{display: "flex", gap: 30}}>
                        <Grid
                            item
                            lg
                            md
                            xl
                            style={{display: "flex", flexDirection: "column"}}
                        >
                            <Typography variant="b" style={{opacity: "0.7"}}>
                                Current Policy Inception Date *
                            </Typography>
                            <DateFilter
                                disableFuture={true}
                                fieldId={"currentPolicyInceptionDate"}
                                selectedDate={formData.currentPolicyInceptionDate}
                                onDateChange={handleDateChange}
                            />
                        </Grid>
                        <Grid
                            item
                            lg
                            md
                            xl
                            style={{display: "flex", flexDirection: "column"}}
                        >
                            <Typography variant="b" style={{opacity: "0.7"}}>
                                Current Policy Start Date *
                            </Typography>
                            <DateFilter
                                disableFuture={true}
                                fieldId={"currentPolicyStartDate"}
                                selectedDate={formData.currentPolicyStartDate}
                                onDateChange={handleDateChange}
                            />
                        </Grid>
                        <Grid
                            item
                            lg
                            md
                            xl
                            style={{display: "flex", flexDirection: "column"}}
                        >
                            <Typography variant="b" style={{opacity: "0.7"}}>
                                Current Policy End Date *
                            </Typography>
                            <DateFilter
                                // disableFuture={true}
                                fieldId={"currentPolicyEndDate"}
                                selectedDate={formData.currentPolicyEndDate}
                                onDateChange={handleDateChange}
                            />
                        </Grid>
                    </Grid>

                    {/* upload doc */}
                    <Grid item xs={12} style={{marginTop: "20px"}}>
                        <label htmlFor="upload-document">
                            <Button
                                aria-label="Upload"
                                variant="outlined"
                                color="primary"
                                component="span"
                                endIcon={<FileUploadIcon/>}
                                style={{padding: "10px 20px"}}
                            >
                                Upload documents
                            </Button>
                        </label>
                        <input
                            type="file"
                            accept="application/pdf"
                            multiple
                            hidden
                            data-testid="uploadDoc"
                            id="upload-document"
                            ref={fileInputRef}
                            onChange={handleDocUpload}
                        />
                    </Grid>

                    {/* DocPreview */}
                    <Grid item xs>
                        {docObjects.length > 0 && (
                            <Typography variant="subtitle1" gutterBottom>
                                Uploaded Documents ({docObjects.length})
                            </Typography>
                        )}

                        <Grid container>
                            {docObjects.map((doc, index) => (
                                <Fragment>
                                    <Grid
                                        item
                                        xs={2}
                                        key={`dockey_${index}`}
                                        //key={index}
                                        style={{
                                            padding: 10,
                                            position: "relative",
                                            maxWidth: "133px",
                                        }}
                                    >
                                        <Grid
                                            item
                                            xs
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "flex-end",
                                                position: "absolute",
                                                width: "100%",
                                                marginLeft: "-18px",
                                            }}
                                        >
                                            <IconButton
                                                size="small"
                                                onClick={() => handleRemoveDocuments(doc, index)}
                                            >
                                                <CloseIcon color="disabled" fontSize="small"/>
                                            </IconButton>
                                        </Grid>
                                        <Grid item sx={{border: "1px solid #00000030"}}>
                                            <div
                                                className={{
                                                    maxHeight: 100,
                                                    maxWidth: 200,
                                                }}
                                            >
                                                <div
                                                    className={{
                                                        height: 160,
                                                        color: "grey",
                                                    }}
                                                >
                                                    <img
                                                        id="target"
                                                        alt="ia"
                                                        src={PDFLOGO}
                                                        height="100"
                                                    />
                                                </div>
                                                <SmallLightTooltip
                                                    title={doc && doc.name ? doc.name : ""}
                                                    placement="bottom"
                                                >
                                                    <div style={{marginLeft: "10px"}}>
                                                        {`${
                                                            doc && doc.name && doc.name.length > 10
                                                                ? doc.name.slice(0, 10)
                                                                : doc.name
                                                        }...`}
                                                    </div>
                                                </SmallLightTooltip>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Fragment>
                            ))}
                        </Grid>
                    </Grid>
                </Grid>

                {/* Submit Button */}
                <Grid
                    item
                    style={{
                        padding: "1.5rem",
                        display: "flex",
                        alignContent: "space-between",
                        justifyContent: "flex-end",
                    }}
                >
                    <Button
                        variant="contained"
                        size="large"
                        color="primary"
                        onClick={handleSubmit}
                        disabled={disableSubmit}
                    >
                        Submit
                    </Button>
                </Grid>
            </form>
        </Grid>
    );
}

export default CreateClaimManual;
